import { connect } from "react-redux"

import Content from "../components/Content"

const mapStateToProps = state => ({ startY: state.screen.height })

export default connect(mapStateToProps, null)(Content)
